import { SaveableFactory } from '®shared/data';

import { ModalControlsSaveable } from './modal-controls-saveable';

export namespace ModalControlsSaveableFactory {
  export function show(): ModalControlsSaveable {
    return Object.assign(SaveableFactory.reset(), {
      isShown: true,
    });
  }

  export function hide(): ModalControlsSaveable {
    return Object.assign(SaveableFactory.reset(), {
      isShown: false,
    });
  }

  export function saving(): ModalControlsSaveable {
    return Object.assign(SaveableFactory.saving(), {
      isShown: true,
    });
  }

  export function errorSaving(error: any): ModalControlsSaveable {
    return Object.assign(SaveableFactory.errorSaving(error), {
      isShown: true,
    });
  }
}
